import {TitleUser} from './title-user';

export default TitleUser;